const moduleName = 'fixedHeader';

export function fixedHeader() {

    Array.from(document.querySelectorAll('.js-fixed-header')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        const hasFixedHeader = 'has-fixed-header';
        const hasOpenedHeader = 'has-opened-header';
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll < 600) {
                body.classList.remove(scrollUp);
                body.classList.remove(hasOpenedHeader);
                //return;
            } else{
                body.classList.add(hasOpenedHeader);
            }

            if (currentScroll > 400 ) {
                body.classList.add(hasFixedHeader);
                //return;
            } else {
                body.classList.remove(hasFixedHeader);
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });

    });
}
